<template>
    <button type="button" name="cph button"
            :class="[classList]"
            :disabled="buttonDisabled"
            :title="`${buttonDisabled ? 'Please fill the form first' : buttonText}`"
            @click.prevent.stop="$emit('clicked')"
            @change.prevent.stop="$emit('change')">
        <slot name="icon"></slot>
        <div class="px-4" v-if="loading">
            <clip-loader :loading="loading" :size="'1em'" :color="'#fff'"/>
        </div>
        <span v-else>{{buttonText | capitalize}}</span>
    </button>
</template>

<script type="text/babel">
import Filters from '../../../../mixins/CphFilters.vue';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
export default {
    name: 'CphButton',
    props: {
        buttonDisabled: {
            default: false
        },
        buttonText: {
            required: true
        },
        classList: {
            default: 'btn btn-cph-primary'
        },
        loading: {
            default: false
        }
    },
    components: {
        ClipLoader
    },
    mixins: [Filters]
};
</script>
